import React from 'react';
import './style.scss';

const TallyTabLoading = () => (
  <div className="busy-integration__loader__wrapper">

    { [...Array(5).keys()].map((item) => (
      <div key={item} className="busy-integration__loader-row">
        <div className="loadingBlock  busy-integration__loader__line1" />
        <div className="loadingBlock  busy-integration__loader__line2" />
        <div className="loadingBlock  busy-integration__loader__line3" />
      </div>
    ))}
    <div className="loadingBlock busy-integration__loader__line-btn1" />
    <div className="loadingBlock busy-integration__loader__line-btn2" />
  </div>
);

export default TallyTabLoading;
